import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("solo-landing-page-header", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-page-header"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
      },
    },
    view: {
      onRender({ model }) {
        model.findType("image").forEach(i =>
          i.set({
            src: "/public-files/logo",
            alt: "logo",
            locked: true,
            editable: false,
            selectable: false,
            hoverable: false,
          })
        );
      },
    },
  });

  BlockManager.add("solo-landing-page-header", {
    ...config,
    label: "Header",
    content: template,
  });
}
